import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import PlaceResult = google.maps.places.PlaceResult;
import AutocompleteOptions = google.maps.places.AutocompleteOptions;
import { Address, GetPlaceResult } from './../models/address';
import { GoogleService } from '../services/google.service';

export enum Appearance {
  STANDARD = 'standard',
  FILL = 'fill',
  OUTLINE = 'outline',
  LEGACY = 'legacy',
}

@Component({
  selector: 'ngx-ggAutocomplete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
  standalone: false
})
export class GGAutoCompleteComponent implements OnInit, OnDestroy {
  @ViewChild('search')
  public searchElementRef: ElementRef;

  @Input()
  addressLabelText = 'Address';

  @Input()
  placeholderText = 'Search address...';

  @Input()
  requiredErrorText = 'The address is required';

  @Input()
  invalidErrorText = 'The address is not valid';

  @Input()
  appearance: string | Appearance = Appearance.STANDARD;

  @Input()
  address: PlaceResult | string = '';

  @Input()
  country: string | string[] = 'us';

  @Input()
  placeIdOnly?: boolean;

  @Input()
  strictBounds?: boolean;

  @Input()
  disabled = false;

  @Input()
  types?: string[];
  // types: string[] = ['address'];

  @Input()
  type?: string;

  @Input()
  autoCompleteOptions: AutocompleteOptions = {};

  @Output()
  onChange: EventEmitter<PlaceResult | string | null> = new EventEmitter<
    PlaceResult | string | null
  >();

  @Output()
  onAutocompleteSelected: EventEmitter<PlaceResult> = new EventEmitter<
    PlaceResult
  >();

  @Output()
  onAddressMapped: EventEmitter<Address> = new EventEmitter<Address>();

  @Output()
  onLocationSelected: EventEmitter<Address> = new EventEmitter<Address>();

  private googleListener: google.maps.MapsEventListener;
  constructor(private ngZone: NgZone, private googleService: GoogleService) { }
  ngOnDestroy(): void {
    this.googleListener?.remove();
  }

  ngOnInit() {
    const options: AutocompleteOptions = {
      //  types: [this.type],
      // componentRestrictions: {country: this.country},
      placeIdOnly: this.placeIdOnly,
      strictBounds: this.strictBounds,
      types: this.types
      // type: this.type,

    };

    this.country
      ? (options.componentRestrictions = { country: this.country })
      : null;

    this.country ? (options.types = this.types) : null;

    this.autoCompleteOptions = Object.assign(this.autoCompleteOptions, options);
    this.initGoogleMapsAutocomplete();
  }

  public initGoogleMapsAutocomplete() {
    // this.mapsAPILoader
    //   .load()
    //   .then(() => {
    this.googleService.load("places").subscribe(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        this.autoCompleteOptions
      );
      this.googleListener = autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: PlaceResult = autocomplete.getPlace();
          const address = GetPlaceResult(place);
          this.onAddressMapped.emit(address);

          if (
            !place.place_id ||
            place.geometry === undefined ||
            place.geometry === null
          ) {
            // place result is not valid
            return;
          } else {
            // show dialog to select a address from the input
            // emit failed event
          }
          this.address = place.formatted_address;
          this.onAutocompleteSelected.emit(place);
          // console.log('onAutocompleteSelected -> ', place);
          this.onLocationSelected.emit(address);
        });
      });

    }, (err) => {
      console.log(err);
    })

  }

  public onQuery(event: any) {
    // console.log('onChange()', event);
    this.onChange.emit(this.address);
  }

  // private resetAddress() {
  //   this.address = null;
  //   this.addressSearchControl.updateValueAndValidity();
  // }
}
